/**
 * Creates a new object containing only the properties from the original object
 * where the value is not undefined.
 *
 * @param obj The object to filter.
 * @returns A new object with undefined fields removed.
 */
export const removeUndefinedFields = <T extends Record<string, any>>(obj: T | Partial<T>): Partial<T> => {
  const newObj: Partial<T> = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined) {
      newObj[key] = obj[key];
    }
  }
  return newObj;
};
